import { render, staticRenderFns } from "./ChecagemFrigobar.vue?vue&type=template&id=c4dc82fa&scoped=true&"
import script from "./ChecagemFrigobar.vue?vue&type=script&lang=js&"
export * from "./ChecagemFrigobar.vue?vue&type=script&lang=js&"
import style0 from "./ChecagemFrigobar.vue?vue&type=style&index=0&id=c4dc82fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc82fa",
  null
  
)

export default component.exports